import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReached = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 26,
	height: 26,
	viewBox: "0 0 26 26",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			width: 26,
			height: 26,
			rx: 13,
			fill: "#FFF3E0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.6004 15.9246L7.45039 12.7746L6.40039 13.8246L10.6004 18.0246L19.6004 9.02461L18.5504 7.97461L10.6004 15.9246Z",
			fill: "#ED6C02"
		})
	]
});
const ForwardRef = forwardRef(SvgReached);
export default ForwardRef;
